import axios from '../http'

function add(data) {
    return axios.post('/basedata/baseRound/add', data);
}

function del(data) {
    return axios.post('/basedata/baseRound/del', data);
}

function update(data) {
    return axios.post('/basedata/baseRound/update', data);
}

function query(data) {
    return axios.post('/basedata/baseRound/query', data);
}


function get(id) {
    return axios.get('/basedata/baseRound/get?id=' + id);
}

function findOptions() {
    return axios.post('/basedata/baseRound/findOptions');
}

export default {
    add,
    del,
    update,
    query,
    get,
    findOptions
}